import './App.css';
import DrumMachine from './DrumMachine';

function App() {
  return (
    <div className="App">
      <DrumMachine />
    </div>
  );
}

export default App;
